import Vue from 'vue'
import AdminLandingEditor from './LandingEditor.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

import {
  faSave, faEdit, faTrash, faPlus, faMinus, faEye, faEyeSlash,
  faSearch, faCog, faCheck, faChevronDown, faChevronUp, faTimes,
  faBars, faUser, faAngleRight, faAngleLeft, faHome, faInfoCircle
} from '@fortawesome/free-solid-svg-icons'


import {
  faCheckCircle
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faSave, faEdit, faTrash, faPlus, faMinus, faEye, faEyeSlash,
  faSearch, faCog, faCheck, faChevronDown, faChevronUp, faTimes,
  faBars, faUser, faAngleRight, faAngleLeft, faHome, faInfoCircle,

  faCheckCircle
)

Vue.use(Toast, {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  hideProgressBar: false,
  icon: true
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('admin-editor')
  if (!el) {
    return
  }

  const payload = JSON.parse(el.getAttribute('data-payload') || '{}')
 
  new Vue({
    el,
    render: h => h(AdminLandingEditor, {
      props: {
        initialData: payload
      }
    })
  })
})